import {
  buildGeolocationGetRequest,
  useFetchApi,
  UseFetchDataResponse
} from "../useFetchApi";
import { Language } from "../../utils/localization/languages/types";
import { CruiseGroupCode } from "@silversea-ssc/web-cruise-groups";
import { Currency } from "../../utils/localization/currency";
import {
  CruiseGroupV2ApiRequest,
  CruiseGroupV2ApiResponse
} from "@silversea-ssc/dotcom-api-types/CruiseGroup";
import { useQuerySearch } from "src/utils/useQueryParams";

export const useRemoteCruiseGroupV2 = (
  cruiseGroupCode: CruiseGroupCode | undefined,
  currency: Currency | undefined,
  countryCode: string | undefined,
  language: Language
): UseFetchDataResponse<CruiseGroupV2ApiResponse> => {
  const enabled = cruiseGroupCode && currency && countryCode;
  const querySearch = useQuerySearch();

  const request = enabled
    ? buildGeolocationGetRequest<CruiseGroupV2ApiRequest>(
        "v2/cruiseGroup",
        {
          cruiseGroup: cruiseGroupCode,
          currency: currency
        },
        querySearch,
        language
      )
    : undefined;

  return useFetchApi<CruiseGroupV2ApiResponse>(request);
};
